<template>
  <story-layout :iframeSrc="imgSource.healthTempsl" iframeId="portfolio-card">
    <template #rightCom>
      <div v-if="showDialog" class="cus-dialog">
        <StoryLayoutRight
        :src="imgSource.healthCoverPic"
        btnText="开启财富体检"
        @click="showDialog = false"
        />
      </div>
      <div v-else class="right-main">
          <module-header title="基础家庭信息" />
      <div>
        <base-info />
      </div>
      </div>
    </template>
  </story-layout>
  <!-- <div class="page-container">
    <module-header title="基础家庭信息" />
    <div>
      <base-info />
    </div>
  </div> -->
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import moduleHeader from '@/components/moduleHeader/index.vue'
import { CommonMudule } from '@/store/modules/common'
import StoryLayout from "@/common/cardMap/storyLayout/index.vue";
import StoryLayoutRight from "@/common/cardMap/storyLayout/rightImgText.vue"
import baseInfo from './template/baseInfo'
import { getFinancialAnalysisInfo } from '@/api/articles'

@Component({
  name: 'financialAnalysis',
  components: {
    moduleHeader,
    baseInfo,
    StoryLayout,
    StoryLayoutRight
  }
})
export default class extends Vue {
  showDialog = true
  get imgSource() {
    return CommonMudule.imgSource;
  }
  created() {
    this.getBaseInfo()
  }
   async getBaseInfo() {
     const res = await getFinancialAnalysisInfo({ customerId: CommonMudule.customerId })
     if(res.statusCode === 0 && res.data?.customer?.familyStatus) {
       this.showDialog = false
     }
  }
}
</script>
